import React from "react";

function Bannerhome(){
    return(
        <div className="container-fluid p-2">
            <img className="col-md-12" src="./images/banner31.jpg" />
        </div>
    )
}

export default Bannerhome